import { ROUTE } from '../routes';

export const PAGE_MAX_WIDTH: Partial<Record<ROUTE, string>> = {
  [ROUTE.SOLAR]: '440px',
  [ROUTE.ELECTRICITY_USAGE]: '440px',
  [ROUTE.HOME]: '812px',
  [ROUTE.SHOP]: '1340px',
  [ROUTE.UTILITY_RATE_PLAN_ENROLLMENT_LANDING]: '640px',
  [ROUTE.UTILITY_RATE_PLAN_OPT_OUT]: '640px',
  [ROUTE.UTILITY_RATE_PLAN_CHOOSE_PLAN]: '640px',
  [ROUTE.UTILITY_RATE_PLAN_ENROLLMENT]: '640px',
} as const;
